import { Component, Input, OnInit } from '@angular/core';
import { Paging } from 'src/app/models/page';
import { ProductCart } from 'src/app/models/product-cart';
import { OrderRequest } from 'src/app/models/requests/order-request';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';

@Component({
  selector: 'giftcard-save-step',
  templateUrl: './giftcard-save-step.component.html',
  styleUrls: ['./giftcard-save-step.component.sass']
})
export class GiftcardSaveStepComponent implements OnInit {

  constructor() { }

  @Input()
  customer: CustomerTableModel = new CustomerTableModel();

  @Input()
  productCart: Paging<Array<ProductCart>> = new Paging([]);

  ngOnInit(): void {
  }

}
